import { getPaletteById, Tag } from "@/models/tag";
import { CustomCellRendererProps } from "@ag-grid-community/react";
import { Badge } from "@mantine/core";

export const TagRenderer = ({
  value,
  getTagOptions,
}: CustomCellRendererProps & {
  getTagOptions: () => Tag[];
}) => {
  const tags = getTagOptions() || [];

  return (
    <div
      style={{
        display: "flex",
        height: 40,
        //overflow: "hidden",
        alignItems: "center",
      }}
    >
      {(value || []).map((tagId: string) => {
        const tag = tags?.find((tag) => tag.id === tagId);
        const color = getPaletteById(tag?.paletteId || "");
        return (
          <Badge
            display={!tag ? "none" : undefined}
            key={tagId}
            size="lg"
            color={color?.backgroundColor}
            variant="filled"
            c={color?.fontColor}
            tt={"none"}
            mr={4}
          >
            {tag?.label}
          </Badge>
        );
      })}
    </div>
  );
};
